// import React from "react";
// import Header from "./Header";
// import HeaderNavigation from "../pages/header";
// import Footer from "../pages/footer";
import StockTicker from "./Ticker";
// export default function Layout({ children }) {
//   return (
//     <>
//       <StockTicker />

//       <HeaderNavigation />
//       {children}
//       <Footer />
//     </>
//   );
// }

import React from "react";
import HeaderNavigation from "../pages/header";
import Footer from "../pages/footer";

// StockTicker removed — it was rendering as a fixed empty gray bar
// (its data fetch was commented out). The PSXTicker on the home page
// still works fine — it lives inside new-home/index.js independently.

export default function Layout({ children }) {
  return (
    <>
     {/* <StockTicker /> */}
      <HeaderNavigation />

      {/* hdr-offset pushes content below the two fixed header bands */}
      <div className="hdr-offset">
        {children}
      </div>

      <Footer />
    </>
  );
}